import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import ScopedCssBaseline from '@material-ui/core/ScopedCssBaseline';
export var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      _ref$scoped = _ref.scoped,
      scoped = _ref$scoped === void 0 ? false : _ref$scoped,
      theme = _ref.theme;
  return (
    /*#__PURE__*/
    React.createElement(MuiThemeProvider, {
      theme: theme
    }, scoped ?
    /*#__PURE__*/
    React.createElement(ScopedCssBaseline, null, React.Children.only(children)) :
    /*#__PURE__*/
    React.createElement(CssBaseline, null, React.Children.only(children)))
  );
};